import React, { useState, useEffect, useMemo } from 'react';
import { supabase } from '../supabase';
import { faturacaoProjetoMes, MESES, eur } from './CommissionsView';
import { LINHA_COR } from '../constants/linhas';

const C = { purple:'#691FB1', purpleLight:'#C6C3E7', purpleDark:'#736CCE', pink:'#FF357B', blue:'#57B1DD', txt:'#2b2b3a', soft:'#6b6b7b', border:'#ECEAF6', white:'#fff' };
const TIPO_COR = { 'Novo':'#691FB1','Retenção':'#736CCE','Upsell':'#57B1DD','Cross':'#FF357B' };
const PALETA = ['#691FB1','#57B1DD','#FF357B','#736CCE','#C6C3E7','#2C6EAF','#BE1356'];

function Donut({ data, size=160, onHover }){
  const total = data.reduce((a,d)=>a+d.value,0);
  const r=size/2-13, cx=size/2, cy=size/2, circ=2*Math.PI*r; let off=0;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <g transform={`rotate(-90 ${cx} ${cy})`}>
        {total>0 ? data.map((d,i)=>{ const len=(d.value/total)*circ;
          const seg=<circle key={i} cx={cx} cy={cy} r={r} fill="none" stroke={d.color} strokeWidth="19" strokeDasharray={`${len} ${circ-len}`} strokeDashoffset={-off} style={{cursor:'pointer'}} onMouseEnter={e=>onHover&&onHover({x:e.clientX,y:e.clientY,label:d.label,val:d.value,pct:total>0?Math.round(d.value/total*100):0, peso:true})} onMouseMove={e=>onHover&&onHover({x:e.clientX,y:e.clientY,label:d.label,val:d.value,pct:total>0?Math.round(d.value/total*100):0, peso:true})} onMouseLeave={()=>onHover&&onHover(null)}/>;
          off+=len; return seg;
        }) : <circle cx={cx} cy={cy} r={r} fill="none" stroke={C.border} strokeWidth="19"/>}
      </g>
    </svg>
  );
}
function Legenda({ data }){
  return <div style={{ display:'flex', flexWrap:'wrap', gap:10, marginTop:10, justifyContent:'center' }}>
    {data.map((d,i)=><span key={i} style={{ display:'flex', alignItems:'center', gap:5, fontSize:12, color:C.txt }}>
      <span style={{ width:10, height:10, borderRadius:3, background:d.color, display:'inline-block' }}/>{d.label} · {eur(d.value)}</span>)}
  </div>;
}

export default function DashboardView({ perms, userEmail, voltar }){
  const anoAtual=new Date().getFullYear();
  const [ano,setAno]=useState(anoAtual);
  const [comercialSel,setComercialSel]=useState('__todos__');
  const [projetos,setProjetos]=useState([]);
  const [sessoes,setSessoes]=useState([]);
  const [objs,setObjs]=useState([]);
  const [loading,setLoading]=useState(true);
  const [tip,setTip]=useState(null);
  const mesHoje = new Date().getMonth()+1;
  const [periodo,setPeriodo]=useState({de:1,ate:12});
  const [custos,setCustos]=useState([]);
  const [custoSessoesCli,setCustoSessoesCli]=useState({});
  const [carteira,setCarteira]=useState([]);        // objetivo anual por cliente e comercial
  const [faturasAno,setFaturasAno]=useState([]);   // faturas do ano, para a execução // cliente_id -> custo total das sessoes (via RPC, evita limite 1000)
  const [clientesMap,setClientesMap]=useState([]);
  const [entidades,setEntidades]=useState([]);      // entidades de faturação (designações fiscais por cliente)
  const [clientesHub,setClientesHub]=useState([]);  // fichas de cliente (id, nome)
  const [verTodosMargem,setVerTodosMargem]=useState(false);
  const [npsData,setNpsData]=useState([]);
  const [detalhe,setDetalhe]=useState(null);          // { nome, cid, fatReal } — cliente aberto ao clicar
  const [areaDeProjeto,setAreaDeProjeto]=useState({}); // todos os projetos: id -> linha de negócio
  const [catalogo,setCatalogo]=useState([]);          // atividades do catálogo com a área

  const podeVerTodos = perms?.canViewFinancial && (perms?.canEditFinancial || perms?.canManageUsers);

  useEffect(()=>{ let on=true; (async()=>{
    setLoading(true);
    const ini=ano+'-01-01', fim=ano+'-12-31';
    const [{data:projs},{data:sess},{data:ob},{data:cust},{data:cln},{data:npsData}] = await Promise.all([
      supabase.from('projects').select('*').eq('active',true).not('commercial_email','is',null).in('status',['Ativo','Concluído']),
      Promise.resolve({data:[]}), // sessoes carregadas em separado (paginado) para evitar limite 1000
      supabase.from('objetivos').select('*').eq('ano',ano),
      supabase.from('custos_projeto').select('cliente_id,projeto_id,valor,mes,categoria,descricao'),
      supabase.from('clientes').select('id,nome'),
      supabase.from('nps_clientes').select('cliente_id,data_medicao,valor').order('data_medicao',{ascending:false}),
    ]);
    if(!on) return;
    // Cliente com vários projetos «Por sessão» sem filtro de atividade: as sessões sem
    // projeto só contam num deles (senão cada projeto somava todas as sessões do cliente).
    const donoSoltas = {};
    (projs||[]).filter(p => p.billing_model==='Por sessão' && !p.atividade_filtro)
      .sort((a,b) => String(a.id).localeCompare(String(b.id)))
      .forEach(p => { const kk = p.cliente_id || (p.client||'').toLowerCase(); if (donoSoltas[kk]) p._naoRecebeSoltas = true; else donoSoltas[kk] = p.id; });
    setProjetos(projs||[]);
    // para o detalhe por cliente: a linha de negócio de qualquer projeto e a área de cada atividade
    supabase.from('projects').select('id,business_area').then(({data})=>{ if(!on) return; const m={}; (data||[]).forEach(p=>{ m[p.id]=p.business_area; }); setAreaDeProjeto(m); });
    supabase.from('catalogo_atividades').select('area,nome').then(({data})=>{ if(on) setCatalogo(data||[]); });
    // Carregar TODAS as sessoes paginado (o Supabase corta em 1000 por query)
    const carregarTodasSessoes = async () => {
      let todas = []; let ini2 = 0; const passo = 1000;
      while (true) {
        const { data, error } = await supabase.from('sessions')
          .select('client,cliente_id,value_agreed,value_to_pay,travel_costs,date,state,activity,projeto_id')
          .gte('date',ini).lte('date',fim)
          .order('date').range(ini2, ini2 + passo - 1);
        if (error || !data || data.length === 0) break;
        todas = todas.concat(data);
        if (data.length < passo) break;
        ini2 += passo;
        if (ini2 > 100000) break;
      }
      return todas;
    };
    const todasSessoes = await carregarTodasSessoes();
    setSessoes(todasSessoes); setObjs(ob||[]); setCustos(cust||[]); setClientesMap(cln||[]); setNpsData(npsData||[]);
    // carteira anual por conta — base da execução comercial
    const { data: cart } = await supabase.from('objetivos_retencao_cliente')
      .select('comercial_email,comercial_nome,cliente,valor').eq('ano', ano);
    setCarteira(cart||[]);
    // faturas do ano — o faturado da execução vem daqui, não do "a faturar" dos projetos
    const fats = [];
    for(let p=0;;p++){
      const { data: ff } = await supabase.from('faturas')
        .select('cliente,nif,valor,valor_liquido,nc_valor,numero,month,data_emissao,estado')
        .gte('data_emissao', ano+'-01-01').lte('data_emissao', ano+'-12-31')
        .order('id',{ascending:true}).range(p*1000, p*1000+999);
      if(!ff || !ff.length) break;
      fats.push(...ff);
      if(ff.length<1000) break;
    }
    setFaturasAno(fats);
    // Entidades de faturação: a fatura sai muitas vezes com o nome da empresa
    // que paga ("Kagome Foods Portugal") e não com o do cliente ("Hit Tomato").
    const { data: ents } = await supabase.from('entidades_faturacao')
      .select('cliente_id,designacao_fiscal,nif').eq('ativo', true);
    const { data: clis } = await supabase.from('clientes').select('id,nome');
    setEntidades(ents||[]); setClientesHub(clis||[]);
    setLoading(false);
  })(); return ()=>{ on=false; }; },[ano]);

  // Custo das sessões, somado na base para não bater no limite de 1000 linhas.
  // TEM de usar o MESMO período da faturação — se trouxesse o ano inteiro
  // enquanto a faturação é só do período escolhido, a margem saía muito abaixo do real.
  useEffect(()=>{ let on=true; (async()=>{
    const hoje = new Date();
    const mesCorte = (ano === hoje.getFullYear()) ? (hoje.getMonth()+1) : 12;
    const ate = Math.min(periodo.ate, mesCorte);
    if(periodo.de > ate){ if(on) setCustoSessoesCli({}); return; }
    const { data: custoCli } = await supabase.rpc('custo_sessoes_por_cliente',
      { ano_ini: ano, mes_ini: periodo.de, mes_fim: ate });
    if(!on) return;
    const mapaCusto = {};
    (custoCli||[]).forEach(r => { mapaCusto[r.cliente_id] = Number(r.custo)||0; });
    setCustoSessoesCli(mapaCusto);
  })(); return ()=>{ on=false; }; },[ano, periodo.de, periodo.ate]);

  const comerciais = useMemo(()=>{ const set={}; projetos.forEach(p=>{ if(p.commercial_email) set[p.commercial_email]=p.commercial_name||p.commercial_email; }); return Object.entries(set).map(([email,nome])=>({email,nome})); },[projetos]);
  const emailsScope = useMemo(()=>{ if(!podeVerTodos) return [userEmail]; if(comercialSel==='__todos__') return comerciais.map(c=>c.email); return [comercialSel]; },[podeVerTodos,comercialSel,comerciais,userEmail]);
  const projsScope = useMemo(()=> projetos.filter(p=>emailsScope.includes(p.commercial_email)),[projetos,emailsScope]);

  const { objAnual, objMes } = useMemo(()=>{ const a={},m={}; objs.forEach(o=>{ if(o.mes==null){ (a[o.comercial_email]=a[o.comercial_email]||{})[o.categoria]=Number(o.valor)||0; } else if(o.categoria==='total'){ (m[o.comercial_email]=m[o.comercial_email]||{})[o.mes]=Number(o.valor)||0; } }); return { objAnual:a, objMes:m }; },[objs]);
  const anualDe = (e)=>{ const o=objAnual[e]||{}; return (o.novas_vendas||0)+(o.retencao||0)+(o.up_cross||0); };
  const recorrenteDe = (e)=>{ const o=objAnual[e]||{}; return (o.retencao||0)+(o.up_cross||0); };
  const novasAnualDe = (e)=>{ const o=objAnual[e]||{}; return (o.novas_vendas||0); };
  const objAnualScope = useMemo(()=> emailsScope.reduce((s,e)=>s+anualDe(e),0),[emailsScope,objAnual]);
  const objetivoMes = (mes)=> emailsScope.reduce((s,e)=>{ const mv=objMes[e]&&objMes[e][mes]; const novas = (mv!=null&&mv>0) ? mv : novasAnualDe(e)/12; return s + novas + recorrenteDe(e)/12; },0);
  const fatProjAno = (p)=>{ let f=0; for(let m=periodo.de;m<=periodo.ate;m++){ f+=faturacaoProjetoMes(p, ano+'-'+String(m).padStart(2,'0'), sessoes); } return f; };

  const linhas = useMemo(()=> MESES.map((nome,i)=>{ const ym=ano+'-'+String(i+1).padStart(2,'0'); let fat=0; projsScope.forEach(p=>{ fat+=faturacaoProjetoMes(p,ym,sessoes); }); return { mes:nome, fat, obj:objetivoMes(i+1) }; }),[projsScope,sessoes,ano,emailsScope,objAnual,objMes]);

  const fatAno = linhas.reduce((a,l,i)=> (i+1>=periodo.de && i+1<=periodo.ate) ? a+l.fat : a, 0);
  const objPeriodo = (()=>{ let o=0; for(let m=periodo.de;m<=periodo.ate;m++) o+=objetivoMes(m); return o; })();
  const vsObj = objPeriodo>0 ? fatAno/objPeriodo : 0;
  const nVendas = useMemo(()=> projsScope.filter(p=>fatProjAno(p)>0).length,[projsScope,sessoes,ano,periodo]);
  const ticket = nVendas>0 ? fatAno/nVendas : 0;
  const projetosAtivos = useMemo(()=> projsScope.filter(p=>{
    if(p.status!=='Ativo') return false;
    if(!p.contract_start||!p.contract_end) return false;
    const sMes=parseInt(p.contract_start.slice(5,7)), sAno=parseInt(p.contract_start.slice(0,4));
    const eMes=parseInt(p.contract_end.slice(5,7)), eAno=parseInt(p.contract_end.slice(0,4));
    // decorre no periodo do ano selecionado se: inicio <= fimPeriodo E fim >= inicioPeriodo (no ano em vista)
    const inicioPer=ano*100+periodo.de, fimPer=ano*100+periodo.ate;
    const inicioCon=sAno*100+sMes, fimCon=eAno*100+eMes;
    return inicioCon<=fimPer && fimCon>=inicioPer;
  }).length,[projsScope,ano,periodo]);
  const clientesScope = useMemo(()=> new Set(projsScope.filter(p=>fatProjAno(p)>0).map(p=>p.cliente_id).filter(Boolean)).size,[projsScope,sessoes,ano,periodo]);

  const porTipo = useMemo(()=>{ const t={}; projsScope.forEach(p=>{ const f=fatProjAno(p); if(f>0){ const k=p.tipo_negocio||'Novo'; t[k]=(t[k]||0)+f; } }); return Object.entries(t).map(([label,value])=>({label,value,color:TIPO_COR[label]||C.soft})); },[projsScope,sessoes,ano,periodo]);
  const porLinha = useMemo(()=>{ const t={}; projsScope.forEach(p=>{ const f=fatProjAno(p); if(f>0){ const k=p.business_area||'(sem linha)'; t[k]=(t[k]||0)+f; } }); return Object.entries(t).map(([label,value],i)=>({label,value,color:LINHA_COR[label]||PALETA[i%PALETA.length]})); },[projsScope,sessoes,ano,periodo]);
  // ── EXECUÇÃO POR CARTEIRA ──
  // Compara o faturado de cada conta com o objetivo anual definido em
  // objetivos_retencao_cliente. O "ritmo" é a fração do ano já decorrida:
  // a meio do ano, uma conta no caminho certo deve estar perto dos 50%.
  const execucao = useMemo(()=>{
    if(!carteira.length) return null;
    const norm = (s)=> (s||'').toString().normalize('NFKD').replace(/[\u0300-\u036f]/g,'')
      .toLowerCase().replace(/[^a-z0-9]/g,'');
    // faturação por cliente no período (mesma base da rentabilidade)
    const _h = new Date();
    // As faturas de um mês saem no mês seguinte: o mês corrente ainda não tem faturação,
    // por isso não entra no ritmo (senão todas as contas pareciam atrasadas).
    const _mesAtual = (ano===_h.getFullYear()) ? Math.max(1, _h.getMonth()) : 12;
    const ateP = Math.min(periodo.ate, _mesAtual);
    // nº de faturas importadas por mês — para avisar quando o último mês ainda está incompleto
    const nPorMes = {};
    faturasAno.forEach(f=>{ const mm = parseInt(String(f.month||f.data_emissao||'').slice(5,7)); if(mm) nPorMes[mm]=(nPorMes[mm]||0)+1; });
    const anteriores = Object.entries(nPorMes).filter(([m])=>Number(m)<ateP).map(([,n])=>n);
    const mediaMes = anteriores.length ? anteriores.reduce((a,b)=>a+b,0)/anteriores.length : 0;
    const ultimoIncompleto = mediaMes>0 && (nPorMes[ateP]||0) < mediaMes*0.7
      ? { mes: ateP, n: nPorMes[ateP]||0, media: Math.round(mediaMes) } : null;

    // Faturado: vem das FATURAS emitidas (líquido de IVA e de notas de crédito),
    // não do "a faturar" dos projetos — que nem sempre está preenchido.
    // Os Wellbeing Games (série WBG) ficam de fora: são evento, não carteira.
    const fatDe = {};
    faturasAno.forEach(f=>{
      if((f.estado||'')==='Anulada') return;
      if(/WBG/i.test(f.numero||'')) return;
      const m = (f.month || f.data_emissao || '').slice(5,7);
      const mm = parseInt(m); if(!mm || mm<periodo.de || mm>ateP) return;
      const bruto = Number(f.valor)||0;
      const liq = Number(f.valor_liquido!=null ? f.valor_liquido : bruto/1.23)||0;
      const nc = Number(f.nc_valor)||0;
      const v = nc && bruto ? Math.max(0, liq - nc*(liq/bruto)) : liq;
      if(v<=0) return;
      const k = norm(f.cliente);
      fatDe[k] = (fatDe[k]||0) + v;
    });

    // ritmo do ano: quantos meses do período já passaram
    const meses = Math.max(0, ateP - periodo.de + 1);
    const ritmo = meses/12;

    // agrupar por comercial
    const porCom = {};
    carteira.forEach(k=>{
      const email = k.comercial_email || '(sem dono)';
      if(!porCom[email]) porCom[email] = { nome: k.comercial_nome || email, contas: [], carteira: 0, faturado: 0 };
      // O nome na carteira é curto ("Tabaqueira") e nas faturas há variantes
      // ("Tabaqueira I"). Somam-se todas as variantes — mas o nome da fatura tem
      // de COMEÇAR pelo da carteira, senão "Alsa Portugal" apanhava a Kagome,
      // os CTT e tudo o que tivesse "portugal" no nome.
      const alvoNorm = norm(k.cliente);
      // Além do nome da carteira, contam as designações fiscais registadas para
      // esse cliente: a "Kagome Foods Portugal" é a entidade da Hit Tomato, e
      // sem isto essas faturas não contavam para ninguém.
      const cli = clientesHub.find(x => {
        const n = norm(x.nome);
        return n === alvoNorm || n.startsWith(alvoNorm) || alvoNorm.startsWith(n);
      });
      const designacoes = cli
        ? entidades.filter(e => e.cliente_id === cli.id).map(e => norm(e.designacao_fiscal)).filter(Boolean)
        : [];
      let fat = 0;
      const usadas = [];
      for(const [nomeFat, v] of Object.entries(fatDe)){
        const porNome = nomeFat === alvoNorm || nomeFat.startsWith(alvoNorm) || alvoNorm.startsWith(nomeFat);
        const porEntidade = designacoes.some(d => nomeFat === d || nomeFat.startsWith(d) || d.startsWith(nomeFat));
        if(porNome || porEntidade){ fat += v; usadas.push(nomeFat); }
      }
      const alvo = Number(k.valor)||0;
      const pct = alvo>0 ? fat/alvo : 0;
      // estado face ao ritmo esperado
      const est = alvo<=0 ? '—'
                : pct >= ritmo*1.15 ? 'acima'
                : pct >= ritmo*0.85 ? 'no ritmo'
                : pct >= ritmo*0.5  ? 'abaixo'
                : pct > 0           ? 'em risco' : 'crítico';
      porCom[email].contas.push({ cliente:k.cliente, cid: cli?.id || null, alvo, fat, pct, est, nVariantes: usadas.length });
      porCom[email].carteira += alvo;
      porCom[email].faturado += fat;
    });
    const lista = Object.entries(porCom).map(([email,v])=>({
      email, ...v,
      pct: v.carteira>0 ? v.faturado/v.carteira : 0,
      contas: v.contas.sort((a,b)=>b.alvo-a.alvo),
    })).sort((a,b)=>b.carteira-a.carteira);

    const emRisco = lista.flatMap(c=>c.contas.filter(x=>x.est==='em risco'||x.est==='crítico')
      .map(x=>({...x, comercial:c.nome}))).sort((a,b)=>b.alvo-a.alvo);

    return {
      lista, ritmo, meses, ateP, ultimoIncompleto,
      totalCarteira: lista.reduce((a,c)=>a+c.carteira,0),
      totalFaturado: lista.reduce((a,c)=>a+c.faturado,0),
      emRisco,
    };
  },[carteira, faturasAno, periodo, ano, entidades, clientesHub]);

  const margemCliente = useMemo(()=>{
    // Corte ao mes atual: nao contar meses futuros (ha previsao de faturacao mas nao de custos)
    const hoje = new Date();
    const mesAtual = (ano === hoje.getFullYear()) ? (hoje.getMonth()+1) : 12;
    const ateMargem = Math.min(periodo.ate, mesAtual);
    const nomeDe = {}; clientesMap.forEach(c=>{ nomeDe[c.id]=c.nome; });
    const projDoCli = {}; // cliente_id -> [projetos] (no scope)
    projsScope.forEach(p=>{ if(!p.cliente_id) return; (projDoCli[p.cliente_id]=projDoCli[p.cliente_id]||[]).push(p); });
    const emPeriodo = (m)=>{ if(!m) return true; const mm=parseInt(String(m).split('-')[1]); return mm>=periodo.de && mm<=ateMargem; };
    const acc = {}; // cliente_id -> {fat,custo}
    const get = (id)=> (acc[id]=acc[id]||{fat:0,custo:0});
    // faturação dos projetos (no período)
    Object.entries(projDoCli).forEach(([cid,arr])=>{ arr.forEach(p=>{ let f=0; for(let mm=periodo.de;mm<=ateMargem;mm++){ f+=faturacaoProjetoMes(p, ano+'-'+String(mm).padStart(2,'0'), sessoes); } get(cid).fat+=f; }); });
    // sessões: faturação e custo (no período) — só clientes que estão no scope (têm projeto do scope)
    // custo das sessoes: usar o mapa pre-somado na base (custoSessoesCli), so para clientes no scope
    Object.keys(projDoCli).forEach(cid => {
      if(custoSessoesCli[cid]) get(cid).custo += custoSessoesCli[cid];
    });
    // custos diretos (no período)
    custos.forEach(cu=>{ if(!cu.cliente_id || !projDoCli[cu.cliente_id]) return; if(!emPeriodo(cu.mes)) return; get(cu.cliente_id).custo+=(Number(cu.valor)||0); });
    return Object.entries(acc).map(([cid,v])=>({ cid, cliente: nomeDe[cid]||'(sem nome)', fat:v.fat, custo:v.custo, margem:v.fat-v.custo, margemPct: v.fat>0?Math.round(((v.fat-v.custo)/v.fat)*100):0 })).filter(x=>x.fat>0||x.custo>0).sort((a,b)=>b.fat-a.fat);
  },[projsScope,sessoes,custos,clientesMap,periodo,ano,custoSessoesCli]);

  const perf = useMemo(()=> comerciais.filter(c=>podeVerTodos||c.email===userEmail).map(c=>{ let f=0; projetos.filter(p=>p.commercial_email===c.email).forEach(p=>{ f+=fatProjAno(p); }); return { nome:(c.nome||'').split(' ')[0], real:f, obj:anualDe(c.email) }; }),[comerciais,projetos,sessoes,ano,objAnual,podeVerTodos,userEmail]);

  const maxMensal = Math.max(1, ...linhas.map(l=>Math.max(l.fat,l.obj)));
  const maxPerf = Math.max(1, ...perf.map(p=>Math.max(p.real,p.obj)));

  const npsGeral = useMemo(()=>{
    const ultimoPorCliente={};
    npsData.forEach(n=>{ if(!(n.cliente_id in ultimoPorCliente)) ultimoPorCliente[n.cliente_id]=n.valor; }); // npsData vem ordenado desc, primeiro = mais recente
    const valores=Object.values(ultimoPorCliente);
    if(valores.length===0) return {media:null, n:0};
    const media=Math.round(valores.reduce((a,b)=>a+Number(b),0)/valores.length);
    return {media, n:valores.length};
  },[npsData]);

  // ── DETALHE DE UM CLIENTE: faturação e custos por linha de negócio no período ──
  const normA = (x)=> String(x||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  const REGRAS_AREA = [
    [/psicolog|psiquiat|\bsono\b|apoio financeiro|juridic|intervencao em crise|primeiros socorros psic|\bgic\b/, 'Mind'],
    [/quickmassage|massag|shiatsu|pilates|\bgl\b|gl presencial|ginastica|fisio|osteo|treino|yoga|zumba|avaliacao fisica|coaching postural|rastreio|caminhada|defesa pessoal|personal trainer|pt pack|pt - pack|mobilidade|visita diagnostico/, 'Vitality'],
    [/webinar|formacao|workshop|talk|mindfulness/, 'Academy'],
    [/\bdj\b|smoothie|showcooking|ceramica|manicure|maquilhagem|promotor|promocao|brain breakfast|granola|candle|ecoflor|mindful garden|recraft|papel mache|tacas tibetanas|active break/, 'Moments'],
  ];
  const areaDaSessao = (se)=>{
    if (se.projeto_id && areaDeProjeto[se.projeto_id]) return areaDeProjeto[se.projeto_id];
    const n = normA(se.activity);
    const c = catalogo.find(x => normA(x.nome) && normA(x.nome) === n);
    if (c) return c.area;
    for (const [re, ar] of REGRAS_AREA) if (re.test(n)) return ar;
    return 'Sem área';
  };
  const abrirCliente = (nome, cid, fatReal)=>{
    let id = cid;
    if (!id) { const nn = normA(nome).replace(/[^a-z0-9]/g,''); const c = clientesHub.find(x => { const m = normA(x.nome).replace(/[^a-z0-9]/g,''); return m===nn || m.startsWith(nn) || nn.startsWith(m); }); id = c?.id || null; }
    setTip(null);
    setDetalhe({ nome, cid:id, fatReal });
  };
  const detalheDados = useMemo(()=>{
    if (!detalhe || !detalhe.cid) return null;
    const _h = new Date();
    const ateP = Math.min(periodo.ate, (ano===_h.getFullYear()) ? (_h.getMonth()+1) : 12);
    const noPer = (ym)=>{ const mm = parseInt(String(ym||'').slice(5,7)); return mm>=periodo.de && mm<=ateP && String(ym).slice(0,4)===String(ano); };
    const A = {}; const g = (a)=> (A[a] = A[a] || { fat:0, custo:0, sessoes:0, atividades:{}, outros:0 });
    // faturação prevista pelos projetos do cliente
    projetos.filter(p => p.cliente_id === detalhe.cid).forEach(p => {
      let f = 0; for (let m = periodo.de; m <= ateP; m++) f += faturacaoProjetoMes(p, ano+'-'+String(m).padStart(2,'0'), sessoes);
      if (f) g(p.business_area || 'Sem área').fat += f;
    });
    // custos das sessões (profissionais + ajudas de custo)
    // sessões antigas importadas só com o nome do cliente (sem ficha) também contam
    const nomeFicha = normA((clientesHub.find(c => c.id === detalhe.cid) || {}).nome);
    const doCliente = (se)=> se.cliente_id ? se.cliente_id === detalhe.cid : (nomeFicha && normA(se.client) === nomeFicha);
    sessoes.forEach(se => {
      if (!doCliente(se) || se.state !== 'confirmed' || !noPer(se.date)) return;
      const v = (Number(se.value_to_pay)||0) + (Number(se.travel_costs)||0); if (!v) return;
      const a = g(areaDaSessao(se)); a.custo += v; a.sessoes++;
      const at = se.activity || '(sem atividade)'; a.atividades[at] = (a.atividades[at]||0) + v;
    });
    // outros custos de projeto (espaço, catering…)
    custos.forEach(cu => {
      if (cu.cliente_id !== detalhe.cid || !noPer(cu.mes)) return;
      const v = Number(cu.valor)||0; if (!v) return;
      const a = g(areaDeProjeto[cu.projeto_id] || 'Sem área'); a.custo += v; a.outros += v;
    });
    const linhas = Object.entries(A).map(([area, v]) => ({ area, ...v, margem: v.fat - v.custo,
      pct: v.fat > 0 ? Math.round((v.fat - v.custo) / v.fat * 100) : null,
      top: Object.entries(v.atividades).sort((a,b)=>b[1]-a[1]).slice(0,4) })).sort((a,b)=> (b.fat+b.custo)-(a.fat+a.custo));
    const tot = linhas.reduce((t,l)=>({ fat:t.fat+l.fat, custo:t.custo+l.custo }), { fat:0, custo:0 });
    return { linhas, tot, ateP };
  },[detalhe, projetos, sessoes, custos, periodo, ano, areaDeProjeto, catalogo, clientesHub]);

  const card = (label,val,sub)=>(
    <div style={{ background:C.white, borderRadius:12, border:'1px solid '+C.border, padding:'16px 18px', flex:1, minWidth:170 }}>
      <div style={{ fontSize:12, color:C.soft, fontWeight:700, textTransform:'uppercase', letterSpacing:'.04em' }}>{label}</div>
      <div style={{ fontSize:26, fontWeight:800, color:C.purple, margin:'4px 0 2px' }}>{val}</div>
      {sub!=null && <div style={{ fontSize:12, color:C.soft }}>{sub}</div>}
    </div>
  );
  const painel = { background:C.white, borderRadius:12, border:'1px solid '+C.border, padding:'16px 18px', flex:1, minWidth:300 };
  const tituloP = { fontSize:14, fontWeight:800, color:C.txt, margin:'0 0 12px' };

  return (
    <div style={{ fontFamily:"'DM Sans',sans-serif", color:C.txt, padding:'24px 32px', boxSizing:'border-box', width:'100%' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16, flexWrap:'wrap', gap:10 }}>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <button onClick={voltar} style={{ background:C.purpleLight, color:C.purple, border:'1px solid '+C.purple, borderRadius:8, padding:'7px 13px', fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:700 }}>← Voltar</button>
          <h2 style={{ margin:0, fontSize:20, color:C.purple }}>📊 Dashboard de vendas</h2>
        </div>
        <div style={{ display:'flex', gap:10 }}>
          <select value={ano} onChange={e=>setAno(parseInt(e.target.value))} style={{ padding:'8px 12px', borderRadius:8, border:'1px solid '+C.purpleLight, fontSize:13, fontFamily:"'DM Sans',sans-serif", color:C.txt }}>
            {[anoAtual-1,anoAtual,anoAtual+1].map(y=><option key={y} value={y}>{y}</option>)}
          </select>
          {podeVerTodos && <select value={comercialSel} onChange={e=>setComercialSel(e.target.value)} style={{ padding:'8px 12px', borderRadius:8, border:'1px solid '+C.purpleLight, fontSize:13, fontFamily:"'DM Sans',sans-serif", color:C.txt }}>
            <option value="__todos__">Todas as comerciais</option>
            {comerciais.map(c=><option key={c.email} value={c.email}>{c.nome}</option>)}
          </select>}
        </div>
      </div>

      <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:16, flexWrap:'wrap' }}>
        {[['Ano',1,12],['Trimestre',Math.max(1,mesHoje-2),mesHoje],['Mês',mesHoje,mesHoje]].map(([lbl,d,a])=>{
          const ativo = periodo.de===d && periodo.ate===a;
          return <button key={lbl} onClick={()=>setPeriodo({de:d,ate:a})} style={{ padding:'6px 14px', borderRadius:8, border:'1px solid '+C.purpleLight, fontSize:13, fontFamily:"'DM Sans',sans-serif", cursor:'pointer', background:ativo?C.purple:'#fff', color:ativo?'#fff':C.txt, fontWeight:ativo?600:400 }}>{lbl}</button>;
        })}
        <span style={{ fontSize:13, color:C.soft, marginLeft:6 }}>De</span>
        <select value={periodo.de} onChange={e=>{ const d=parseInt(e.target.value); setPeriodo(p=>({de:d,ate:Math.max(d,p.ate)})); }} style={{ padding:'6px 10px', borderRadius:8, border:'1px solid '+C.purpleLight, fontSize:13, fontFamily:"'DM Sans',sans-serif", color:C.txt }}>
          {MESES.map((nm,i)=><option key={i} value={i+1}>{nm}</option>)}
        </select>
        <span style={{ fontSize:13, color:C.soft }}>até</span>
        <select value={periodo.ate} onChange={e=>{ const a=parseInt(e.target.value); setPeriodo(p=>({de:Math.min(a,p.de),ate:a})); }} style={{ padding:'6px 10px', borderRadius:8, border:'1px solid '+C.purpleLight, fontSize:13, fontFamily:"'DM Sans',sans-serif", color:C.txt }}>
          {MESES.map((nm,i)=><option key={i} value={i+1}>{nm}</option>)}
        </select>
      </div>

      {loading ? <p style={{ color:C.soft }}>A carregar…</p> : <>
        <div style={{ display:'flex', gap:12, marginBottom:16, flexWrap:'wrap' }}>
          {card('Faturado no período', eur(fatAno), ano+(comercialSel==='__todos__'||!podeVerTodos?' · toda a equipa':''))}
          {card('Vs objetivo', Math.round(vsObj*100)+'%', 'objetivo: '+eur(objPeriodo))}
          {card('Clientes a faturar', clientesScope, comercialSel==='__todos__'||!podeVerTodos?'toda a equipa':'do comercial')}
          {card('Projetos ativos', projetosAtivos, 'status Ativo')}
          {card('Ticket médio', eur(ticket), 'por projeto')}
          {card('NPS geral', npsGeral.media!=null?npsGeral.media:'—', npsGeral.n>0?npsGeral.n+' clientes avaliados':'sem avaliações')}
        </div>

        <div style={{ ...painel, marginBottom:16 }}>
          <div style={tituloP}>Evolução mensal · faturado vs objetivo</div>
          <svg viewBox="0 0 720 230" style={{ width:'100%', height:'auto' }}>
            {[0,0.5,1].map((g,gi)=>{ const y=200-g*180; return <g key={gi}><line x1="0" y1={y} x2="720" y2={y} stroke={C.border}/><text x="0" y={y-3} fontSize="9" fill={C.soft}>{eur(maxMensal*g)}</text></g>; })}
            {linhas.map((l,i)=>{ const x=i*60+10, hF=(l.fat/maxMensal)*180, hO=(l.obj/maxMensal)*180; return <g key={i}>
              <rect x={x} y={200-hO} width={16} height={hO} fill={C.purpleLight} rx="2" opacity={(i+1>=periodo.de && i+1<=periodo.ate)?1:0.3} style={{cursor:'pointer'}} onMouseEnter={e=>setTip({x:e.clientX,y:e.clientY,label:l.mes+' · objetivo',val:l.obj})} onMouseMove={e=>setTip(t=>t?{...t,x:e.clientX,y:e.clientY}:t)} onMouseLeave={()=>setTip(null)}/>
              <rect x={x+18} y={200-hF} width={16} height={hF} fill={C.purple} rx="2" opacity={(i+1>=periodo.de && i+1<=periodo.ate)?1:0.3} style={{cursor:'pointer'}} onMouseEnter={e=>setTip({x:e.clientX,y:e.clientY,label:l.mes+' · faturado',val:l.fat})} onMouseMove={e=>setTip(t=>t?{...t,x:e.clientX,y:e.clientY}:t)} onMouseLeave={()=>setTip(null)}/>
              <text x={x+17} y={216} fontSize="10" fill={C.soft} textAnchor="middle">{l.mes}</text>
            </g>; })}
          </svg>
          <div style={{ display:'flex', gap:16, marginTop:8, fontSize:12, color:C.soft }}>
            <span style={{ display:'flex', alignItems:'center', gap:5 }}><span style={{ width:11, height:11, background:C.purple, borderRadius:3 }}/>Faturado</span>
            <span style={{ display:'flex', alignItems:'center', gap:5 }}><span style={{ width:11, height:11, background:C.purpleLight, borderRadius:3 }}/>Objetivo</span>
          </div>
        </div>

        <div style={{ display:'flex', gap:16, marginBottom:16, flexWrap:'wrap' }}>
          <div style={painel}>
            <div style={tituloP}>Tipo de venda</div>
            <div style={{ display:'flex', justifyContent:'center' }}><Donut data={porTipo} onHover={setTip}/></div>
            <Legenda data={porTipo}/>
          </div>
          <div style={painel}>
            <div style={tituloP}>Linha de negócio</div>
            <div style={{ display:'flex', justifyContent:'center' }}><Donut data={porLinha} onHover={setTip}/></div>
            <Legenda data={porLinha}/>
          </div>
        </div>

        <div style={painel}>
          <div style={tituloP}>Performance por comercial · real vs objetivo</div>
          {perf.length===0 ? <p style={{ color:C.soft, fontSize:13 }}>Sem dados.</p> :
          perf.map((p,i)=>(
            <div key={i} style={{ marginBottom:12 }}>
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:4 }}><b>{p.nome}</b><span style={{ color:C.soft }}>{eur(p.real)} / {eur(p.obj)} · {p.obj>0?Math.round(p.real/p.obj*100):0}%</span></div>
              <div style={{ background:C.border, borderRadius:6, height:18, position:'relative' }}>
                <div style={{ background:C.purpleLight, height:18, borderRadius:6, width:(p.obj/maxPerf*100)+'%', position:'absolute', top:0, left:0 }}/>
                <div style={{ background:C.purple, height:18, borderRadius:6, width:(p.real/maxPerf*100)+'%', position:'absolute', top:0, left:0 }}/>
              </div>
            </div>
          ))}
        </div>

        {/* ── EXECUÇÃO POR CARTEIRA ── */}
        {execucao && execucao.lista.length>0 && (() => {
          const E = execucao;
          const corEst = { 'acima':'#0E7C66', 'no ritmo':'#27AE60', 'abaixo':'#C9A227',
                           'em risco':'#E67E22', 'crítico':'#C0392B', '—':C.soft };
          const fundoEst = { 'acima':'#E8F6F2', 'no ritmo':'#EAFAF1', 'abaixo':'#FEF9E7',
                             'em risco':'#FDF0E3', 'crítico':'#FDECEA', '—':'#F7F7FA' };
          const pctGlobal = E.totalCarteira>0 ? E.totalFaturado/E.totalCarteira : 0;

          return (
            <div style={{ ...painel, marginTop:16, minWidth:'100%' }}>
              <div style={tituloP}>Execução por carteira · faturado vs objetivo de retenção</div>
              <div style={{ fontSize:11.5, color:C.soft, marginBottom:14 }}>
                {MESES[periodo.de-1]}{E.ateP!==periodo.de ? ' a '+MESES[E.ateP-1] : ''} · {E.meses} de 12 meses
                ({Math.round(E.ritmo*100)}% do ano). Uma conta &quot;no ritmo&quot; está perto dessa percentagem.
                {' '}O mês corrente fica de fora: a faturação de um mês só sai no início do seguinte.
                {E.ultimoIncompleto && <div style={{ marginTop:6, padding:'6px 10px', background:'#FFF6E0', border:'1px solid #F1C40F66', borderRadius:8, color:'#8A6D00' }}>
                  ⚠ {MESES[E.ultimoIncompleto.mes-1]} ainda parece incompleto: só há {E.ultimoIncompleto.n} faturas importadas (a média dos meses anteriores é {E.ultimoIncompleto.media}). Importa o mapa de vendas mais recente antes de tirar conclusões.
                </div>}
              </div>

              {/* barra global */}
              <div style={{ marginBottom:18, padding:'13px 16px', background:C.purpleLight, borderRadius:10 }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:6, flexWrap:'wrap', gap:8 }}>
                  <span style={{ fontSize:13, fontWeight:700, color:C.purple }}>Carteira total</span>
                  <span style={{ fontSize:12.5, color:C.txt }}>
                    <strong style={{ fontSize:16 }}>{eur(E.totalFaturado)}</strong>
                    <span style={{ color:C.soft }}> de {eur(E.totalCarteira)} · </span>
                    <strong style={{ color: pctGlobal>=E.ritmo ? '#27AE60' : '#C9A227' }}>
                      {Math.round(pctGlobal*100)}%</strong>
                  </span>
                </div>
                <div style={{ position:'relative', height:12, background:'#fff', borderRadius:6 }}>
                  <div style={{ position:'absolute', left:0, top:0, height:12, borderRadius:6,
                    width:Math.min(100,pctGlobal*100)+'%',
                    background: pctGlobal>=E.ritmo ? '#27AE60' : '#C9A227' }}/>
                  <div style={{ position:'absolute', left:Math.min(100,E.ritmo*100)+'%', top:-3,
                    width:2, height:18, background:C.purple }} title={`ritmo esperado: ${Math.round(E.ritmo*100)}%`}/>
                </div>
                <div style={{ fontSize:10.5, color:C.soft, marginTop:5 }}>
                  A marca roxa é o ritmo esperado ({Math.round(E.ritmo*100)}%).
                </div>
              </div>

              {/* por comercial */}
              {E.lista.map(com => (
                <div key={com.email} style={{ marginBottom:20 }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline',
                    marginBottom:7, flexWrap:'wrap', gap:8 }}>
                    <span style={{ fontSize:14, fontWeight:700, color:C.txt }}>{com.nome}</span>
                    <span style={{ fontSize:12, color:C.soft }}>
                      carteira {eur(com.carteira)} ·
                      <strong style={{ color: com.pct>=E.ritmo*0.85 ? '#27AE60' : '#C9A227', marginLeft:5 }}>
                        {Math.round(com.pct*100)}%</strong>
                      <span style={{ marginLeft:5 }}>{eur(com.faturado)} faturado</span>
                    </span>
                  </div>
                  <div style={{ overflowX:'auto' }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12.5 }}>
                      <thead><tr style={{ background:'#FAF8FF' }}>
                        {['Conta','Carteira','Faturado','%','Estado'].map((h,i)=>(
                          <th key={h} style={{ padding:'7px 11px', fontSize:10.5, color:C.soft,
                            textTransform:'uppercase', letterSpacing:0.4, fontWeight:600,
                            textAlign:i===0?'left':(i===4?'center':'right'), whiteSpace:'nowrap' }}>{h}</th>
                        ))}
                      </tr></thead>
                      <tbody>
                        {com.contas.map((ct,i)=>(
                          <tr key={ct.cliente} style={{ borderTop:'1px solid '+C.border,
                            background:i%2?'#FCFBFF':'#fff' }}>
                            <td onClick={()=>abrirCliente(ct.cliente, ct.cid, ct.fat)} title="Ver faturação e custos por linha de negócio"
                              style={{ padding:'7px 11px', color:C.purple, cursor:'pointer', textDecoration:'underline', textDecorationColor:'#D9D2F0' }}>
                              {ct.cliente}
                              {ct.nVariantes > 1 && (
                                <span title={`Somadas ${ct.nVariantes} designações de faturação`}
                                  style={{ fontSize:9.5, color:C.soft, marginLeft:6 }}>+{ct.nVariantes-1}</span>
                              )}
                            </td>
                            <td style={{ padding:'7px 11px', textAlign:'right', color:C.soft, whiteSpace:'nowrap' }}>{eur(ct.alvo)}</td>
                            <td style={{ padding:'7px 11px', textAlign:'right', fontWeight:600, whiteSpace:'nowrap' }}>{eur(ct.fat)}</td>
                            <td style={{ padding:'7px 11px', textAlign:'right', fontWeight:700,
                              color:corEst[ct.est], whiteSpace:'nowrap' }}>{Math.round(ct.pct*100)}%</td>
                            <td style={{ padding:'7px 11px', textAlign:'center' }}>
                              <span style={{ fontSize:10.5, fontWeight:700, padding:'2px 9px', borderRadius:10,
                                background:fundoEst[ct.est], color:corEst[ct.est], whiteSpace:'nowrap' }}>{ct.est}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}

              {/* contas em risco */}
              {E.emRisco.length>0 && (
                <div style={{ marginTop:6, padding:'13px 16px', background:'#FDECEA',
                  border:'1px solid #F5B7B1', borderRadius:10 }}>
                  <div style={{ fontSize:13, fontWeight:700, color:'#C0392B', marginBottom:8 }}>
                    Contas em risco — {E.emRisco.length} {E.emRisco.length===1?'conta':'contas'} ·
                    {' '}{eur(E.emRisco.reduce((a,x)=>a+x.alvo,0))} de carteira
                  </div>
                  {E.emRisco.slice(0,12).map(ct=>(
                    <div key={ct.comercial+ct.cliente} style={{ display:'flex', gap:10, alignItems:'baseline',
                      padding:'4px 0', fontSize:12.5, flexWrap:'wrap' }}>
                      <span onClick={()=>abrirCliente(ct.cliente, ct.cid, ct.fat)} title="Ver faturação e custos por linha de negócio"
                        style={{ fontWeight:600, minWidth:150, cursor:'pointer', textDecoration:'underline', textDecorationColor:'#F5B7B1' }}>{ct.cliente}</span>
                      <span style={{ color:C.soft, fontSize:11 }}>{ct.comercial}</span>
                      <span style={{ flex:1 }}/>
                      <span style={{ color:C.soft }}>{eur(ct.fat)} de {eur(ct.alvo)}</span>
                      <strong style={{ color:corEst[ct.est], minWidth:38, textAlign:'right' }}>
                        {Math.round(ct.pct*100)}%</strong>
                    </div>
                  ))}
                  {E.emRisco.length>12 && (
                    <div style={{ fontSize:11.5, color:C.soft, marginTop:6 }}>
                      e mais {E.emRisco.length-12}…
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })()}

        <div style={{ ...painel, marginTop:16, minWidth:'100%' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:4 }}>
            <div style={tituloP}>Rentabilidade por cliente · faturação × margem</div>
            {(() => {
              const M = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
              const hoje = new Date();
              const corte = (ano === hoje.getFullYear()) ? (hoje.getMonth()+1) : 12;
              const ate = Math.min(periodo.ate, corte);
              const cortado = ate < periodo.ate;
              return (
                <div style={{ fontSize:11.5, color:C.soft, marginTop:2 }}>
                  {M[periodo.de-1]} a {M[ate-1]} de {ano} · faturação e custos do mesmo período
                  {cortado && <span> — os meses seguintes não entram porque ainda não têm custos lançados</span>}
                </div>
              );
            })()}
            <button onClick={()=>setVerTodosMargem(v=>!v)} style={{ background:'#fff', border:'1px solid '+C.purpleLight, borderRadius:8, fontSize:12, padding:'5px 12px', cursor:'pointer', color:C.purple }}>{verTodosMargem?'Top 20':'Ver todos'}</button>
          </div>
          <div style={{ fontSize:12, color:C.soft, marginBottom:10 }}>Cada cliente é uma célula · cor = margem % (verde forte = mais rentável) · passa o rato para ver os detalhes.</div>
          {(()=>{
            const dados = (verTodosMargem?margemCliente:margemCliente.slice(0,20)).slice().sort((a,b)=>b.margemPct-a.margemPct);
            if(dados.length===0) return <p style={{ color:C.soft, fontSize:13 }}>Sem dados de margem no período.</p>;
            // cor por margem %: vermelho (<=0) -> amarelo (~50) -> verde forte (>=80)
            const corMargem = (pct)=>{
              if(pct<=0) return '#E74C3C';
              if(pct<25) return '#E67E22';
              if(pct<50) return '#F1C40F';
              if(pct<75) return '#7DCEA0';
              return '#27AE60';
            };
            return (
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(120px, 1fr))', gap:8 }}>
                {dados.map((d,i)=>{
                  const cor = corMargem(d.margemPct);
                  const txtCor = d.margemPct>=50 ? '#fff' : '#1A1A2E';
                  return (
                    <div key={i}
                      onMouseEnter={e=>setTip({x:e.clientX,y:e.clientY,label:d.cliente,fat:d.fat,val:d.margem,pct:d.margemPct})}
                      onMouseMove={e=>setTip(t=>t?{...t,x:e.clientX,y:e.clientY}:t)}
                      onMouseLeave={()=>setTip(null)}
                      onClick={()=>abrirCliente(d.cliente, d.cid, null)}
                      style={{ background:cor, borderRadius:10, padding:'12px 10px', cursor:'pointer', minHeight:64, display:'flex', flexDirection:'column', justifyContent:'space-between', transition:'transform 0.1s', boxShadow:'0 1px 3px rgba(0,0,0,0.12)' }}>
                      <div style={{ fontSize:13, fontWeight:700, color:txtCor, lineHeight:1.2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{d.cliente}</div>
                      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginTop:6 }}>
                        <span style={{ fontSize:12, fontWeight:600, color:txtCor, opacity:0.9 }}>{eur(d.fat)}</span>
                        <span style={{ fontSize:13, fontWeight:800, color:txtCor }}>{d.margemPct}%</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}
        </div>
      </>}
      {detalhe && (
        <div onClick={()=>setDetalhe(null)} style={{ position:'fixed', inset:0, background:'rgba(26,26,46,0.55)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9000, padding:16 }}>
          <div onClick={e=>e.stopPropagation()} style={{ background:'#fff', borderRadius:14, padding:'20px 22px', width:'min(720px, 100%)', maxHeight:'88vh', overflowY:'auto' }}>
            <div style={{ display:'flex', alignItems:'baseline', gap:10 }}>
              <div style={{ fontSize:18, fontWeight:800, color:C.purple }}>{detalhe.nome}</div>
              <div style={{ fontSize:12.5, color:C.soft }}>{MESES[periodo.de-1]}{detalheDados && detalheDados.ateP!==periodo.de ? ' a '+MESES[detalheDados.ateP-1] : ''} {ano}</div>
              <span style={{ flex:1 }}/>
              <button onClick={()=>setDetalhe(null)} style={{ border:'none', background:'none', fontSize:20, cursor:'pointer', color:C.soft }}>×</button>
            </div>
            {!detalhe.cid ? (
              <div style={{ marginTop:14, fontSize:13, color:C.soft }}>Não encontrei a ficha deste cliente no HUB — não há projetos nem sessões associados para mostrar.</div>
            ) : !detalheDados || !detalheDados.linhas.length ? (
              <div style={{ marginTop:14, fontSize:13, color:C.soft }}>Sem faturação prevista nem custos registados neste período.</div>
            ) : (<>
              <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13, marginTop:14 }}>
                <thead><tr style={{ background:'#FAF8FF' }}>
                  {['Linha de negócio','Faturação','Custos','Margem','%'].map((h,i)=>(
                    <th key={h} style={{ padding:'8px 10px', fontSize:10.5, color:C.soft, textTransform:'uppercase', letterSpacing:0.4, textAlign:i===0?'left':'right' }}>{h}</th>))}
                </tr></thead>
                <tbody>
                  {detalheDados.linhas.map(l=>(
                    <tr key={l.area} style={{ borderTop:'1px solid '+C.border, verticalAlign:'top' }}>
                      <td style={{ padding:'8px 10px' }}>
                        <span style={{ display:'inline-block', width:9, height:9, borderRadius:3, background:LINHA_COR[l.area]||'#bbb', marginRight:6 }}/>
                        <strong>{l.area}</strong>
                        {(l.top.length>0 || l.outros>0) && <div style={{ fontSize:11, color:C.soft, marginTop:3, lineHeight:1.45 }}>
                          {l.top.map(([a,v])=><div key={a}>{a} · {eur(v)}</div>)}
                          {l.outros>0 && <div>Outros custos de projeto · {eur(l.outros)}</div>}
                          {l.sessoes>0 && <div>{l.sessoes} sessões</div>}
                        </div>}
                      </td>
                      <td style={{ padding:'8px 10px', textAlign:'right', fontWeight:600 }}>{eur(l.fat)}</td>
                      <td style={{ padding:'8px 10px', textAlign:'right' }}>{eur(l.custo)}</td>
                      <td style={{ padding:'8px 10px', textAlign:'right', fontWeight:700, color:l.margem<0?'#C0392B':C.txt }}>{eur(l.margem)}</td>
                      <td style={{ padding:'8px 10px', textAlign:'right', fontWeight:700, color:l.pct==null?C.soft:(l.pct<0?'#C0392B':l.pct<30?'#E67E22':'#27AE60') }}>{l.pct==null?'—':l.pct+'%'}</td>
                    </tr>))}
                  <tr style={{ borderTop:'2px solid '+C.border, background:'#FAF8FF' }}>
                    <td style={{ padding:'8px 10px', fontWeight:800 }}>Total</td>
                    <td style={{ padding:'8px 10px', textAlign:'right', fontWeight:800 }}>{eur(detalheDados.tot.fat)}</td>
                    <td style={{ padding:'8px 10px', textAlign:'right', fontWeight:800 }}>{eur(detalheDados.tot.custo)}</td>
                    <td style={{ padding:'8px 10px', textAlign:'right', fontWeight:800 }}>{eur(detalheDados.tot.fat-detalheDados.tot.custo)}</td>
                    <td style={{ padding:'8px 10px', textAlign:'right', fontWeight:800 }}>{detalheDados.tot.fat>0?Math.round((detalheDados.tot.fat-detalheDados.tot.custo)/detalheDados.tot.fat*100)+'%':'—'}</td>
                  </tr>
                </tbody>
              </table>
              <div style={{ fontSize:11.5, color:C.soft, marginTop:10, lineHeight:1.5 }}>
                Faturação = o que os projetos do cliente faturam no período (valor do projeto ou sessões a faturar), repartida pela linha de negócio de cada projeto.
                Custos = sessões pagas aos profissionais e ajudas de custo (pela linha do projeto da sessão ou, sem projeto, pela atividade) e outros custos de projeto.
                {detalhe.fatReal!=null && <> Faturas emitidas no período: <strong>{eur(detalhe.fatReal)}</strong>{Math.abs(detalhe.fatReal-detalheDados.tot.fat)>1 ? ` — diferença de ${eur(detalhe.fatReal-detalheDados.tot.fat)} face aos projetos.` : '.'}</>}
              </div>
            </>)}
          </div>
        </div>
      )}
      {tip && <div style={{ position:'fixed', left:tip.x+12, top:tip.y-8, background:'#2b2b3a', color:'#fff', padding:'8px 12px', borderRadius:8, fontSize:12, fontWeight:600, pointerEvents:'none', zIndex:9999, whiteSpace:'nowrap', boxShadow:'0 4px 16px rgba(0,0,0,0.25)' }}>
        <div style={{ fontWeight:700, marginBottom:3 }}>{tip.label}</div>
        {tip.fat!=null && <div style={{ opacity:0.85 }}>Faturação: {eur(tip.fat)}</div>}
        {tip.pct!=null && <div style={{ opacity:0.85 }}>{tip.peso ? `${tip.pct}% do total` : `Margem: ${tip.pct}%`}</div>}
        {tip.val!=null && <div style={{ opacity:0.85 }}>{tip.peso ? 'Faturação' : 'Margem €'}: {eur(tip.val)}</div>}
      </div>}
    </div>
  );
}
